export default "__VITE_ASSET__BAfdEpYi__"